import { INPUT_VAT_OPTION, SUPPLIER_OPTION, EXPENSE_OPTION, PAYMENT_OPTION, CURRENCY_TYPE, CODETYPE_OPTIONS} from "../../../services/account-api.constants";

export interface AutoCompleteFieldAction 
{
  updates: Array<{ targetField: string, sourceProperty: string }>;
  afterSelectFn: string | undefined; // Name of a function to call after assignment
  openAdditionalDialog : {transValue: string, icon: string, dialogFunction: string} | undefined;
}

export interface FieldRules
{
	bothFilledOrEmpty: Array<{ sourceField: string, dependentFields: string[] }> // Allow multiple rules: each rule states that when `sourceField` has a value, all `dependentFields` must also have values.
}

export const FEATURE_FIELD_DICT: { [key: string]: string } = {
	'ID': 'JMT_COL_ID',
	'MT': 'JMT_COL_MOVE_TYPE',
	'CodeSugTnua': 'JMT_COL_CODE_MOVE_TYPE',
	'Asmakhta_Rishona': 'JMT_COL_FIRST_REF',
	'Asmakhta_Shiya': 'JMT_COL_SECOND_REF',
	'Taarikh_Asmakhta': 'JMT_COL_DATE_REF',
	'Taarikh_Erekh': 'JMT_COL_VAL_DATE',
	'Code_Tamkhir': 'JMT_COL_PRICING_CODE',
	'Code_Matbea': 'JMT_COL_COIN_CODE',
	'Pratim': 'JMT_COL_DETAILS',
	'Kheshbon_Khova_1': 'JMT_COL_HOVA_1_ACCOUNT',
	'Kheshbon_Khova_2': 'JMT_COL_HOVA_2_ACCOUNT',
	'Kheshbon_Zkhut_1': 'JMT_COL_ZHUT_1_ACCOUNT',
	'Kheshbon_Zkhut_2': 'JMT_COL_ZHUT_2_ACCOUNT',
	'Skhum_khova_1_shek': 'JMT_COL_AMOUNT_HOVA_1_NIS',
	'Skhum_khova_2_shek': 'JMT_COL_AMOUNT_HOVA_2_NIS',
	'Skhum_Zkhut_1_shek': 'JMT_COL_AMOUNT_ZHUT_1_NIS',
	'Skhum_Zkhut_2_shek': 'JMT_COL_AMOUNT_ZHUT_2_NIS',
	'Skhum_khova_1_matbea_khutz': 'JMT_COL_AMOUNT_HOVA_1_NO_NIS',
	'Skhum_khova_2_matbea_khutz': 'JMT_COL_AMOUNT_HOVA_2_NO_NIS',
	'Skhum_Zkhuta_1_matbea_khutz': 'JMT_COL_AMOUNT_ZHUT_1_NO_NIS',
	'Skhum_Zkhuta_2_matbea_khutz': 'JMT_COL_AMOUNT_ZHUT_2_NO_NIS',
	'Taarikh_3': 'JMT_COL_DATE_3',
	'Asmakhta_3': 'JMT_COL_REF_3',
	'Kamut': 'JMT_COL_AMOUNT',
	'Kovetz': 'JMT_COL_DOC',
	'Hearot_Nosafot': 'JMT_COL_ADDITIONAL_COMMENTS',
	'Hearot_Nosafot_2': 'JMT_COL_ADDITIONAL_COMMENTS_2',
	'Snif': 'JMT_COL_BRANCH',
	'Mispar_Osek_Murshe': 'JMT_COL_BUSINESS_ID',
	'Asmakhta_4': 'JMT_COL_REF_4',
	'Asmakhta_5': 'JMT_COL_REF_5',
	'Taarikh_4': 'JMT_COL_DATE_4',
	'Taarikh_5': 'JMT_COL_DATE_5',
	'Mispar_Haktzaa': 'JMT_COL_ALLOC_NUMBER',
	'OriginalFileName': 'JMT_COL_ORIG_FILE_NAME',
	'FileName': 'JMT_COL_WATCH_N_EDIT',
	'FileRecID': 'doc_num',
	'URL': 'JMT_DOWNLOAD_JOURNAL_MOVE',
	'MoveIn': 'JMT_VAL_REC_MOVE',
	'Kheshbon_Khova_1_name': 'JMT_COL_HOVA_1_NAME',
	'Kheshbon_Zkhut_1_name': 'JMT_COL_ZHUT_1_ACCOUNT_NAME',
	'Kheshbon_Khova_2_name': 'JMT_COL_HOVA_2_NAME',
	'CustomerName': 'JMT_COL_CUST_NAME'
};
// eye-dialog.constanst.ts
// Field names and field type definitions for EyeDialogComponent

export type FieldType = 'number' | 'money' | 'text' | 'autocomplete' | 'date';

export interface FieldConfig {
	name: string;
	toExport: boolean;
	type: FieldType;

	hasFunction1?: boolean; // If field has fuction, this one is true, used for fields that are not autocomplete and has a function to operate it, in MT0.
	hasFunction2?: boolean; // If field has fuction, this one is true, used for fields that are not autocomplete and has a function to operate it, in MT1.

	
	editable1: boolean; // Is editable for MT0
	editable2: boolean; // Is editable for MT1
	
	autoCompleteKey1?: string; // If type is 'autocomplete', this is the key for the API - editable for MT0
	autoCompleteKey2?: string; // If type is 'autocomplete', this is the key for the API - editable for MT1
	/**
	 * If type is 'autocomplete', this defines which property/properties of the API result to use as the label in the dropdown.
	 * If set to a string, that property will be used as the label.
	 * If set to a string array, the label will be a concatenation of those properties, separated by ' | '.
	 * Example: ['Business_ID', 'Supplier_Name'] => '123456 | My Supplier'
	 * Use autoCompleteLabelProps1 for MT0, autoCompleteLabelProps2 for MT1.
	 */
	autoCompleteLabelProps1?: string | string[];
	autoCompleteLabelProps2?: string | string[];
}

// List of all feature field names (copied from allColumnFields)
export const FEATURE_FIELD_NAMES = [
	'ID', 'MT', 'Mispar_Haktzaa', 'Mispar_Osek_Murshe', 'CustomerName', 'Asmakhta_Rishona', 'Asmakhta_Shiya', 'Taarikh_Asmakhta',
	'Taarikh_Erekh', 'Code_Tamkhir', 'Code_Matbea', 'Pratim', 
	'Kheshbon_Khova_1', 'Kheshbon_Khova_1_name', 'CodeSugTnua', 'Kheshbon_Khova_2', 'Kheshbon_Khova_2_name', 'Kheshbon_Zkhut_1', 'Kheshbon_Zkhut_1_name', 'Kheshbon_Zkhut_2',
	'Skhum_khova_1_shek', 'Skhum_khova_2_shek', 'Skhum_Zkhut_1_shek', 'Skhum_Zkhut_2_shek',
	'Skhum_khova_1_matbea_khutz', 'Skhum_khova_2_matbea_khutz', 'Skhum_Zkhuta_1_matbea_khutz',
	'Skhum_Zkhuta_2_matbea_khutz', 'Taarikh_3', 'Asmakhta_3', 'Kamut', 'Kovetz',
	'Hearot_Nosafot', 'Hearot_Nosafot_2', 'Snif', 'Asmakhta_4',
	'Asmakhta_5', 'Taarikh_4', 'Taarikh_5', 'FileRecID', 'OriginalFileName',
	// 'FileName', 'URL', 'MoveIn' // commented out as in original
];

// Example: Define editable fields and their types
// You should update this list according to your business logic
export const FEATURE_FIELD_CONFIG: FieldConfig[] = [
	{ name: 'ID', 							toExport: true,  type: 'number', 		hasFunction1 : false, hasFunction2:false, editable1: false, editable2: false },
	{ name: 'MT', 							toExport: true,  type: 'text',			hasFunction1 : false, hasFunction2:false, editable1: false, editable2: false },
	{ name: 'Mispar_Haktzaa', 				toExport: true,  type: 'number', 		hasFunction1 : false, hasFunction2:false, editable1: true , editable2: false },
	{ name: 'Mispar_Osek_Murshe', 			toExport: true,  type: 'autocomplete', 	hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true,  autoCompleteKey1: SUPPLIER_OPTION, autoCompleteKey2: SUPPLIER_OPTION, autoCompleteLabelProps1: ['Business_ID', 'Supplier_Name'], autoCompleteLabelProps2: ['Business_ID', 'Supplier_Name'] }, // Field of Business_ID
	{ name: 'CustomerName', 				toExport: true,  type: 'autocomplete', 	hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true, 	autoCompleteKey1: SUPPLIER_OPTION, autoCompleteKey2: SUPPLIER_OPTION, autoCompleteLabelProps1: ['Business_ID', 'Supplier_Name'], autoCompleteLabelProps2: ['Business_ID', 'Supplier_Name'] }, // Field of Supplier_Name
	{ name: 'CodeSugTnua', 					toExport: true,  type: 'autocomplete', 	hasFunction1 : true , hasFunction2:false, editable1: true , editable2: false, autoCompleteKey1: CODETYPE_OPTIONS, autoCompleteLabelProps1: ['CodeMoveType','Expenses_Before_VAT','Input_VAT','Expenses_With_VAT']},
	{ name: 'Asmakhta_Rishona', 			toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Asmakhta_Shiya', 				toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Taarikh_Asmakhta', 			toExport: true,  type: 'date', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Taarikh_Erekh',				toExport: true,  type: 'date', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Code_Tamkhir', 				toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Code_Matbea', 					toExport: true,  type: 'autocomplete', 	hasFunction1 : false, hasFunction2:false, editable1: true , editable2: false, autoCompleteKey1: CURRENCY_TYPE, autoCompleteLabelProps1: ['Code','symbol', 'name']},
	{ name: 'Pratim', 						toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Kheshbon_Khova_1', 			toExport: true,  type: 'autocomplete', 	hasFunction1 : true , hasFunction2:false, editable1: true , editable2: true, 	autoCompleteKey1: EXPENSE_OPTION, autoCompleteKey2: SUPPLIER_OPTION, autoCompleteLabelProps1: ['ExpenseCode', 'Descr', 'CodeMoveType'], autoCompleteLabelProps2: ['CustomerSupplierExpenseCode', 'Description', 'Business_ID', 'Supplier_Name'] }, // For MT0 its actually autocomplete
	{ name: 'Kheshbon_Khova_1_name', 		toExport: true,  type: 'autocomplete', 	hasFunction1 : true , hasFunction2:false, editable1: true , editable2: true, 	autoCompleteKey1: EXPENSE_OPTION, autoCompleteKey2: SUPPLIER_OPTION, autoCompleteLabelProps1: ['ExpenseCode', 'Descr', 'CodeMoveType'], autoCompleteLabelProps2: ['CustomerSupplierExpenseCode', 'Description', 'Business_ID', 'Supplier_Name'] }, // For MT0 its actually autocomplete
	{ name: 'Kheshbon_Khova_2', 			toExport: true,  type: 'autocomplete', 	hasFunction1 : true , hasFunction2:true , editable1: true , editable2: true, autoCompleteKey1: INPUT_VAT_OPTION, autoCompleteLabelProps1: ['customer_vat_expences_num','name'], autoCompleteKey2: INPUT_VAT_OPTION, autoCompleteLabelProps2: ['customer_vat_expences_num','name']},
	{ name: 'Kheshbon_Khova_2_name', 		toExport: true,  type: 'autocomplete', 	hasFunction1 : true , hasFunction2:true , editable1: true , editable2: true, autoCompleteKey1: INPUT_VAT_OPTION, autoCompleteLabelProps1: ['customer_vat_expences_num','name'], autoCompleteKey2: INPUT_VAT_OPTION, autoCompleteLabelProps2: ['customer_vat_expences_num','name']}, 
	{ name: 'Kheshbon_Zkhut_1',           	toExport: true,  type: 'autocomplete',  hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true, autoCompleteKey1: SUPPLIER_OPTION, autoCompleteLabelProps1: ['customer_supplier_num','Description','Business_ID','Supplier_Name','CodeMoveType'], autoCompleteKey2: PAYMENT_OPTION, autoCompleteLabelProps2: ['PaymentAccountNum', 'ItemAccountName']},
	{ name: 'Kheshbon_Zkhut_1_name',      	toExport: true,  type: 'autocomplete',  hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true, autoCompleteKey1: SUPPLIER_OPTION, autoCompleteLabelProps1: ['customer_supplier_num','Description','Business_ID','Supplier_Name','CodeMoveType'], autoCompleteKey2: PAYMENT_OPTION, autoCompleteLabelProps2: ['PaymentAccountNum', 'ItemAccountName']},
	{ name: 'Kheshbon_Zkhut_2', 			toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Skhum_khova_1_shek', 			toExport: true,  type: 'money', 		hasFunction1 : false, hasFunction2:false, editable1: false , editable2:false },
	{ name: 'Skhum_khova_2_shek', 			toExport: true,  type: 'money', 		hasFunction1 : true , hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Skhum_Zkhut_1_shek', 			toExport: true,  type: 'money', 		hasFunction1 : true , hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Skhum_Zkhut_2_shek', 			toExport: true,  type: 'money', 		hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Skhum_khova_1_matbea_khutz', 	toExport: true,  type: 'money', 		hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Skhum_khova_2_matbea_khutz', 	toExport: true,  type: 'money', 		hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Skhum_Zkhuta_1_matbea_khutz', 	toExport: true,  type: 'money', 		hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Skhum_Zkhuta_2_matbea_khutz', 	toExport: true,  type: 'money', 		hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Taarikh_3', 					toExport: true,  type: 'date', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Asmakhta_3',			 		toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Kamut', 						toExport: true,  type: 'number', 		hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Kovetz', 						toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Hearot_Nosafot', 				toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Hearot_Nosafot_2', 			toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Snif', 						toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Asmakhta_4', 					toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Asmakhta_5',	 				toExport: true,  type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Taarikh_4', 					toExport: true,  type: 'date', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'Taarikh_5', 					toExport: true,  type: 'date', 			hasFunction1 : false, hasFunction2:false, editable1: true , editable2: true },
	{ name: 'FileRecID', 					toExport: false, type: 'number', 		hasFunction1 : false, hasFunction2:false, editable1: false, editable2: false },
	{ name: 'OriginalFileName', 			toExport: false, type: 'text', 			hasFunction1 : false, hasFunction2:false, editable1: false, editable2: false },
	{ name: 'SupplierRecID', 				toExport: false, type:'number',	 		hasFunction1 : false, hasFunction2:false, editable1: false, editable2: false  },
	{ name: 'Input_VAT', 					toExport: false, type:'number',			hasFunction1 : false, hasFunction2:false, editable1: false, editable2: false }
	// Add more or adjust as needed
];



export const AUTOCOMPLETE_FIELD_ACTIONS_MT0: { [changedField: string]: AutoCompleteFieldAction } =
{
	'Kheshbon_Khova_2': // Same for Kheshbon_Khova_2_name
	{
		updates: [
			{ targetField: 'Kheshbon_Khova_2', sourceProperty: 'customer_vat_expences_num' },
			{ targetField: 'Kheshbon_Khova_2_name', sourceProperty: 'name' }
		],
		afterSelectFn: 'setVatZero',
		openAdditionalDialog: undefined
	},

	'Kheshbon_Khova_2_name': // Same for Kheshbon_Khova_2
	{
		updates: [
			{ targetField: 'Kheshbon_Khova_2', sourceProperty: 'customer_vat_expences_num' },
			{ targetField: 'Kheshbon_Khova_2_name', sourceProperty: 'name' }
		],
		afterSelectFn: 'setVatZero',
		openAdditionalDialog: undefined
	},

	'Kheshbon_Khova_1': // Same for Kheshbon_Khova_1_name
	{
		updates: [
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'ExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Descr' },
			{ targetField: 'CodeSugTnua', sourceProperty: 'CodeMoveType' },
			{ targetField: 'Input_VAT', sourceProperty: 'Input_VAT' },
		],
		afterSelectFn: 'checkAffectOfCodeMoveType',
		openAdditionalDialog: undefined
	},

	'Kheshbon_Khova_1_name': // Same for Kheshbon_Khova_1
	{
		updates: [
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'ExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Descr' },
			{ targetField: 'CodeSugTnua', sourceProperty: 'CodeMoveType' },
			{ targetField: 'Input_VAT', sourceProperty: 'Input_VAT' },
		],
		afterSelectFn: 'checkAffectOfCodeMoveType',
		openAdditionalDialog: undefined
	},

	'Kheshbon_Zkhut_1': // Same for Kheshbon_Zkhut_1_name
	{
		updates: [
			{ targetField: 'Kheshbon_Zkhut_1', sourceProperty: 'customer_supplier_num' },
			{ targetField: 'Kheshbon_Zkhut_1_name', sourceProperty: 'Supplier_Name' },
			{ targetField: 'Mispar_Osek_Murshe', sourceProperty: 'Business_ID' },
			{ targetField: 'CustomerName', sourceProperty: 'Supplier_Name' },
			{ targetField: 'SupplierRecID', sourceProperty: 'SupplierRecID' },
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'CustomerSupplierExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Description' },
			{ targetField: 'CodeSugTnua', sourceProperty: 'CodeMoveType' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: {transValue:'CREATE_SUPPLIER_HINT', icon: 'pi pi-plus', dialogFunction: 'openKheshbonZkhutDialog' }
	},


	'Kheshbon_Zkhut_1_name': // Same for Kheshbon_Zkhut_1
	{
		updates: [
			{ targetField: 'Kheshbon_Zkhut_1', sourceProperty: 'customer_supplier_num' },
			{ targetField: 'Kheshbon_Zkhut_1_name', sourceProperty: 'Supplier_Name' },
			{ targetField: 'Mispar_Osek_Murshe', sourceProperty: 'Business_ID' },
			{ targetField: 'CustomerName', sourceProperty: 'Supplier_Name' },
			{ targetField: 'SupplierRecID', sourceProperty: 'SupplierRecID' },
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'CustomerSupplierExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Description' },
			{ targetField: 'CodeSugTnua', sourceProperty: 'CodeMoveType' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: {transValue:'CREATE_SUPPLIER_HINT', icon: 'pi pi-plus', dialogFunction: 'openKheshbonZkhutDialog' }
	},


	'Mispar_Osek_Murshe': // Same for CustomerName
	{
		updates: [
			{ targetField: 'Kheshbon_Zkhut_1', sourceProperty: 'customer_supplier_num' },
			{ targetField: 'Kheshbon_Zkhut_1_name', sourceProperty: 'Supplier_Name' },
			{ targetField: 'Mispar_Osek_Murshe', sourceProperty: 'Business_ID' },
			{ targetField: 'CustomerName', sourceProperty: 'Supplier_Name' },
			{ targetField: 'SupplierRecID', sourceProperty: 'SupplierRecID' },
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'CustomerSupplierExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Description' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: undefined
	},
	
	'CustomerName': // Same for Mispar_Osek_Murshe
	{
		updates: [
			{ targetField: 'Kheshbon_Zkhut_1', sourceProperty: 'customer_supplier_num' },
			{ targetField: 'Kheshbon_Zkhut_1_name', sourceProperty: 'Supplier_Name' },
			{ targetField: 'Mispar_Osek_Murshe', sourceProperty: 'Business_ID' },
			{ targetField: 'CustomerName', sourceProperty: 'Supplier_Name' },
			{ targetField: 'SupplierRecID', sourceProperty: 'SupplierRecID' },
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'CustomerSupplierExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Description' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: undefined
	},

	'Code_Matbea' :
	{
		updates: [
			{ targetField: 'Code_Matbea', sourceProperty: 'Code' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: undefined
	},

	'CodeSugTnua' :
	{
		updates: [
			{ targetField: 'CodeSugTnua', sourceProperty: 'CodeMoveType' },
			{ targetField: 'Input_VAT', sourceProperty: 'Input_VAT' },
		],
		afterSelectFn: 'checkAffectOfCodeMoveType',
		openAdditionalDialog: undefined
	},

	

	'Skhum_Zkhut_1_shek':
	{
		updates: [],
		afterSelectFn: 'checkAffectOfCodeMoveType',
		openAdditionalDialog: undefined
	},

	'Skhum_khova_2_shek':
	{
		updates: [],
		afterSelectFn: 'recalculateTotalWithoutTax',
		openAdditionalDialog: undefined
	}
};


export const AUTOCOMPLETE_FIELD_ACTIONS_MT1: { [changedField: string]: AutoCompleteFieldAction } =
{
	'Code_Matbea' :
	{
		updates: [
			{ targetField: 'Code_Matbea', sourceProperty: 'Code' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: undefined
	},
	'Kheshbon_Khova_1': // Same for Kheshbon_Khova_1_name
	{
		updates: [
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'CustomerSupplierExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Description' },
			{ targetField: 'Mispar_Osek_Murshe', sourceProperty: 'Business_ID' },
			{ targetField: 'CustomerName', sourceProperty: 'Supplier_Name' },
			{ targetField: 'SupplierRecID', sourceProperty: 'SupplierRecID' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: undefined
	},

	'Kheshbon_Khova_1_name': // Same for Kheshbon_Khova_1
	{
		updates: [
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'CustomerSupplierExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Description' },
			{ targetField: 'Mispar_Osek_Murshe', sourceProperty: 'Business_ID' },
			{ targetField: 'CustomerName', sourceProperty: 'Supplier_Name' },
			{ targetField: 'SupplierRecID', sourceProperty: 'SupplierRecID' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: undefined
	},

	'Mispar_Osek_Murshe': // Same for CustomerName
	{
		updates: [
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'CustomerSupplierExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Description' },
			{ targetField: 'Mispar_Osek_Murshe', sourceProperty: 'Business_ID' },
			{ targetField: 'CustomerName', sourceProperty: 'Supplier_Name' },
			{ targetField: 'SupplierRecID', sourceProperty: 'SupplierRecID' },
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'CustomerSupplierExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Description' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: undefined
	},
    
	'CustomerName': // Same for Mispar_Osek_Murshe
	{
		updates: [
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'CustomerSupplierExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Description' },
			{ targetField: 'Mispar_Osek_Murshe', sourceProperty: 'Business_ID' },
			{ targetField: 'CustomerName', sourceProperty: 'Supplier_Name' },
			{ targetField: 'SupplierRecID', sourceProperty: 'SupplierRecID' },
			{ targetField: 'Kheshbon_Khova_1', sourceProperty: 'CustomerSupplierExpenseCode' },
			{ targetField: 'Kheshbon_Khova_1_name', sourceProperty: 'Description' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: undefined
	},


	'Kheshbon_Zkhut_1': // Same for Kheshbon_Zkhut_1_name
	{
		updates: [
			{ targetField: 'Kheshbon_Zkhut_1', sourceProperty: 'PaymentAccountNum' },
			{ targetField: 'Kheshbon_Zkhut_1_name', sourceProperty: 'PaymentType' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: undefined
	},


	'Kheshbon_Zkhut_1_name': // Same for Kheshbon_Zkhut_1
	{
		updates: [
			{ targetField: 'Kheshbon_Zkhut_1', sourceProperty: 'PaymentAccountNum' },
			{ targetField: 'Kheshbon_Zkhut_1_name', sourceProperty: 'PaymentType' },
		],
		afterSelectFn: undefined,
		openAdditionalDialog: undefined
	},

	'Kheshbon_Khova_2': // Same for Kheshbon_Khova_2_name
	{
		updates: [
			{ targetField: 'Kheshbon_Khova_2', sourceProperty: 'customer_vat_expences_num' },
			{ targetField: 'Kheshbon_Khova_2_name', sourceProperty: 'name' }
		],
		afterSelectFn: 'setVatZero',
		openAdditionalDialog: undefined
	},

	'Kheshbon_Khova_2_name': // Same for Kheshbon_Khova_2
	{
		updates: [
			{ targetField: 'Kheshbon_Khova_2', sourceProperty: 'customer_vat_expences_num' },
			{ targetField: 'Kheshbon_Khova_2_name', sourceProperty: 'name' }
		],
		afterSelectFn: 'setVatZero',
		openAdditionalDialog: undefined
	},
};


export const FIELD_RULES: FieldRules = 
{
	bothFilledOrEmpty: [
		{
			sourceField: 'Skhum_khova_1_shek',
			dependentFields: ['Kheshbon_Khova_1', 'Kheshbon_Khova_1_name']
		},
		{
			sourceField: 'Skhum_khova_2_shek',
			dependentFields: ['Kheshbon_Khova_2', 'Kheshbon_Khova_2_name']
		},
		{
			sourceField: 'Skhum_Zkhut_1_shek',
			dependentFields:['Kheshbon_Zkhut_1','Kheshbon_Zkhut_1_name']
		}
	]
};